// name  = official/common currency name
// code  = ISO 4217 alphabetic currency code
// symbol = commonly used symbol (not guaranteed unique — several currencies
// share "$", "£", "₨", "kr", etc. Use `code` as the canonical unique key.)
import { useEffect, useState } from 'react';
import { useAuth } from 'auth/Auth';
import { fetchCurrencies } from 'api/countriesNow';

const CURRENCIES = [
    { name: "Afghan Afghani", code: "AFN", symbol: "؋" },
    { name: "Albanian Lek", code: "ALL", symbol: "L" },
    { name: "Algerian Dinar", code: "DZD", symbol: "د.ج" },
    { name: "Euro", code: "EUR", symbol: "€" },
    { name: "Angolan Kwanza", code: "AOA", symbol: "Kz" },
    { name: "East Caribbean Dollar", code: "XCD", symbol: "$" },
    { name: "Argentine Peso", code: "ARS", symbol: "$" },
    { name: "Armenian Dram", code: "AMD", symbol: "֏" },
    { name: "Aruban Florin", code: "AWG", symbol: "ƒ" },
    { name: "Australian Dollar", code: "AUD", symbol: "$" },
    { name: "Azerbaijani Manat", code: "AZN", symbol: "₼" },
    { name: "Bahamian Dollar", code: "BSD", symbol: "$" },
    { name: "Bahraini Dinar", code: "BHD", symbol: ".د.ب" },
    { name: "Bangladeshi Taka", code: "BDT", symbol: "৳" },
    { name: "Barbadian Dollar", code: "BBD", symbol: "$" },
    { name: "Belarusian Ruble", code: "BYN", symbol: "Br" },
    { name: "Belize Dollar", code: "BZD", symbol: "$" },
    { name: "West African CFA Franc", code: "XOF", symbol: "CFA" },
    { name: "Bermudian Dollar", code: "BMD", symbol: "$" },
    { name: "Bhutanese Ngultrum", code: "BTN", symbol: "Nu." },
    { name: "Bolivian Boliviano", code: "BOB", symbol: "Bs." },
    { name: "Bosnia-Herzegovina Convertible Mark", code: "BAM", symbol: "KM" },
    { name: "Botswana Pula", code: "BWP", symbol: "P" },
    { name: "Brazilian Real", code: "BRL", symbol: "R$" },
    { name: "Brunei Dollar", code: "BND", symbol: "$" },
    { name: "Bulgarian Lev", code: "BGN", symbol: "лв" },
    { name: "Burundian Franc", code: "BIF", symbol: "FBu" },
    { name: "Cambodian Riel", code: "KHR", symbol: "៛" },
    { name: "Central African CFA Franc", code: "XAF", symbol: "FCFA" },
    { name: "Canadian Dollar", code: "CAD", symbol: "$" },
    { name: "Cape Verdean Escudo", code: "CVE", symbol: "$" },
    { name: "Cayman Islands Dollar", code: "KYD", symbol: "$" },
    { name: "Chilean Peso", code: "CLP", symbol: "$" },
    { name: "Chinese Yuan", code: "CNY", symbol: "¥" },
    { name: "Colombian Peso", code: "COP", symbol: "$" },
    { name: "Comorian Franc", code: "KMF", symbol: "CF" },
    { name: "Congolese Franc", code: "CDF", symbol: "FC" },
    { name: "Costa Rican Colón", code: "CRC", symbol: "₡" },
    { name: "Cuban Peso", code: "CUP", symbol: "$" },
    { name: "Czech Koruna", code: "CZK", symbol: "Kč" },
    { name: "Danish Krone", code: "DKK", symbol: "kr" },
    { name: "Djiboutian Franc", code: "DJF", symbol: "Fdj" },
    { name: "Dominican Peso", code: "DOP", symbol: "RD$" },
    { name: "Egyptian Pound", code: "EGP", symbol: "£" },
    { name: "Eritrean Nakfa", code: "ERN", symbol: "Nfk" },
    { name: "Eswatini Lilangeni", code: "SZL", symbol: "L" },
    { name: "Ethiopian Birr", code: "ETB", symbol: "Br" },
    { name: "Falkland Islands Pound", code: "FKP", symbol: "£" },
    { name: "Fijian Dollar", code: "FJD", symbol: "$" },
    { name: "Gambian Dalasi", code: "GMD", symbol: "D" },
    { name: "Georgian Lari", code: "GEL", symbol: "₾" },
    { name: "Ghanaian Cedi", code: "GHS", symbol: "₵" },
    { name: "Gibraltar Pound", code: "GIP", symbol: "£" },
    { name: "Guatemalan Quetzal", code: "GTQ", symbol: "Q" },
    { name: "Guinean Franc", code: "GNF", symbol: "FG" },
    { name: "Guyanese Dollar", code: "GYD", symbol: "$" },
    { name: "Haitian Gourde", code: "HTG", symbol: "G" },
    { name: "Honduran Lempira", code: "HNL", symbol: "L" },
    { name: "Hong Kong Dollar", code: "HKD", symbol: "$" },
    { name: "Hungarian Forint", code: "HUF", symbol: "Ft" },
    { name: "Icelandic Króna", code: "ISK", symbol: "kr" },
    { name: "Indian Rupee", code: "INR", symbol: "₹" },
    { name: "Indonesian Rupiah", code: "IDR", symbol: "Rp" },
    { name: "Iranian Rial", code: "IRR", symbol: "﷼" },
    { name: "Iraqi Dinar", code: "IQD", symbol: "ع.د" },
    { name: "Israeli New Shekel", code: "ILS", symbol: "₪" },
    { name: "Jamaican Dollar", code: "JMD", symbol: "$" },
    { name: "Japanese Yen", code: "JPY", symbol: "¥" },
    { name: "Jordanian Dinar", code: "JOD", symbol: "د.ا" },
    { name: "Kazakhstani Tenge", code: "KZT", symbol: "₸" },
    { name: "Kenyan Shilling", code: "KES", symbol: "KSh" },
    { name: "North Korean Won", code: "KPW", symbol: "₩" },
    { name: "South Korean Won", code: "KRW", symbol: "₩" },
    { name: "Kuwaiti Dinar", code: "KWD", symbol: "د.ك" },
    { name: "Kyrgyzstani Som", code: "KGS", symbol: "с" },
    { name: "Lao Kip", code: "LAK", symbol: "₭" },
    { name: "Lebanese Pound", code: "LBP", symbol: "ل.ل" },
    { name: "Lesotho Loti", code: "LSL", symbol: "L" },
    { name: "Liberian Dollar", code: "LRD", symbol: "$" },
    { name: "Libyan Dinar", code: "LYD", symbol: "ل.د" },
    { name: "Macanese Pataca", code: "MOP", symbol: "MOP$" },
    { name: "Malagasy Ariary", code: "MGA", symbol: "Ar" },
    { name: "Malawian Kwacha", code: "MWK", symbol: "MK" },
    { name: "Malaysian Ringgit", code: "MYR", symbol: "RM" },
    { name: "Maldivian Rufiyaa", code: "MVR", symbol: ".ރ" },
    { name: "Mauritanian Ouguiya", code: "MRU", symbol: "UM" },
    { name: "Mauritian Rupee", code: "MUR", symbol: "₨" },
    { name: "Mexican Peso", code: "MXN", symbol: "$" },
    { name: "Moldovan Leu", code: "MDL", symbol: "L" },
    { name: "Mongolian Tögrög", code: "MNT", symbol: "₮" },
    { name: "Moroccan Dirham", code: "MAD", symbol: "د.م." },
    { name: "Mozambican Metical", code: "MZN", symbol: "MT" },
    { name: "Myanmar Kyat", code: "MMK", symbol: "K" },
    { name: "Namibian Dollar", code: "NAD", symbol: "$" },
    { name: "Nepalese Rupee", code: "NPR", symbol: "₨" },
    { name: "Netherlands Antillean Guilder", code: "ANG", symbol: "ƒ" },
    { name: "New Zealand Dollar", code: "NZD", symbol: "$" },
    { name: "Nicaraguan Córdoba", code: "NIO", symbol: "C$" },
    { name: "Nigerian Naira", code: "NGN", symbol: "₦" },
    { name: "Norwegian Krone", code: "NOK", symbol: "kr" },
    { name: "Omani Rial", code: "OMR", symbol: "﷼" },
    { name: "Pakistani Rupee", code: "PKR", symbol: "₨" },
    { name: "Panamanian Balboa", code: "PAB", symbol: "B/." },
    { name: "Papua New Guinean Kina", code: "PGK", symbol: "K" },
    { name: "Paraguayan Guaraní", code: "PYG", symbol: "₲" },
    { name: "Peruvian Sol", code: "PEN", symbol: "S/" },
    { name: "Philippine Peso", code: "PHP", symbol: "₱" },
    { name: "Polish Złoty", code: "PLN", symbol: "zł" },
    { name: "British Pound Sterling", code: "GBP", symbol: "£" },
    { name: "Qatari Rial", code: "QAR", symbol: "﷼" },
    { name: "Romanian Leu", code: "RON", symbol: "lei" },
    { name: "Russian Ruble", code: "RUB", symbol: "₽" },
    { name: "Rwandan Franc", code: "RWF", symbol: "FRw" },
    { name: "Saint Helena Pound", code: "SHP", symbol: "£" },
    { name: "Samoan Tālā", code: "WST", symbol: "T" },
    { name: "São Tomé and Príncipe Dobra", code: "STN", symbol: "Db" },
    { name: "Saudi Riyal", code: "SAR", symbol: "﷼" },
    { name: "Serbian Dinar", code: "RSD", symbol: "дин." },
    { name: "Seychellois Rupee", code: "SCR", symbol: "₨" },
    { name: "Sierra Leonean Leone", code: "SLL", symbol: "Le" },
    { name: "Singapore Dollar", code: "SGD", symbol: "$" },
    { name: "Solomon Islands Dollar", code: "SBD", symbol: "$" },
    { name: "Somali Shilling", code: "SOS", symbol: "S" },
    { name: "South African Rand", code: "ZAR", symbol: "R" },
    { name: "South Sudanese Pound", code: "SSP", symbol: "£" },
    { name: "Sri Lankan Rupee", code: "LKR", symbol: "₨" },
    { name: "Sudanese Pound", code: "SDG", symbol: "£" },
    { name: "Surinamese Dollar", code: "SRD", symbol: "$" },
    { name: "Swedish Krona", code: "SEK", symbol: "kr" },
    { name: "Swiss Franc", code: "CHF", symbol: "CHF" },
    { name: "Syrian Pound", code: "SYP", symbol: "£" },
    { name: "New Taiwan Dollar", code: "TWD", symbol: "$" },
    { name: "Tajikistani Somoni", code: "TJS", symbol: "ЅМ" },
    { name: "Tanzanian Shilling", code: "TZS", symbol: "TSh" },
    { name: "Thai Baht", code: "THB", symbol: "฿" },
    { name: "Tongan Paʻanga", code: "TOP", symbol: "T$" },
    { name: "Trinidad and Tobago Dollar", code: "TTD", symbol: "$" },
    { name: "Tunisian Dinar", code: "TND", symbol: "د.ت" },
    { name: "Turkish Lira", code: "TRY", symbol: "₺" },
    { name: "Turkmenistani Manat", code: "TMT", symbol: "m" },
    { name: "Ugandan Shilling", code: "UGX", symbol: "USh" },
    { name: "Ukrainian Hryvnia", code: "UAH", symbol: "₴" },
    { name: "UAE Dirham", code: "AED", symbol: "د.إ" },
    { name: "United States Dollar", code: "USD", symbol: "$" },
    { name: "Uruguayan Peso", code: "UYU", symbol: "$" },
    { name: "Uzbekistani Som", code: "UZS", symbol: "soʻm" },
    { name: "Vanuatu Vatu", code: "VUV", symbol: "VT" },
    { name: "Venezuelan Bolívar Soberano", code: "VES", symbol: "Bs.S" },
    { name: "Vietnamese Đồng", code: "VND", symbol: "₫" },
    { name: "CFP Franc", code: "XPF", symbol: "₣" },
    { name: "Yemeni Rial", code: "YER", symbol: "﷼" },
    { name: "Zambian Kwacha", code: "ZMW", symbol: "ZK" },
    { name: "Zimbabwe Gold", code: "ZWG", symbol: "ZiG" },
];

// -----------------------------------------------------------------------------
// Supported / enabled currencies
// -----------------------------------------------------------------------------
// Add a currency code here to enable it.
// Remove/comment a currency code to disable it.
//
// Example:
// "USD" -> enabled
// "EUR" -> enabled
// "JPY" -> enabled
//
// A currency NOT present in this Set is considered disabled.
const SUPPORTED_CODES = new Set([
    "AFN", "ALL", "DZD", "EUR", "AOA", "XCD", "ARS", "AMD", "AWG",
    "AUD", "AZN", "BSD", "BHD", "BDT", "BBD", "BYN", "BZD", "XOF",
    "BMD", "BTN", "BOB", "BAM", "BWP", "BRL", "BND", "BGN", "BIF",
    "KHR", "XAF", "CAD", "CVE", "KYD", "CLP", "CNY", "COP", "KMF",
    "CDF", "CRC", "CUP", "CZK", "DKK", "DJF", "DOP", "EGP", "ERN",
    "SZL", "ETB", "FKP", "FJD", "GMD", "GEL", "GHS", "GIP", "GTQ",
    "GNF", "GYD", "HTG", "HNL", "HKD", "HUF", "ISK", "INR", "IDR",
    "IRR", "IQD", "ILS", "JMD", "JPY", "JOD", "KZT", "KES", "KPW",
    "KRW", "KWD", "KGS", "LAK", "LBP", "LSL", "LRD", "LYD", "MOP",
    "MGA", "MWK", "MYR", "MVR", "MRU", "MUR", "MXN", "MDL", "MNT",
    "MAD", "MZN", "MMK", "NAD", "NPR", "ANG", "NZD", "NIO", "NGN",
    "NOK", "OMR", "PKR", "PAB", "PGK", "PYG", "PEN", "PHP", "PLN",
    "GBP", "QAR", "RON", "RUB", "RWF", "SHP", "WST", "STN", "SAR",
    "RSD", "SCR", "SLL", "SGD", "SBD", "SOS", "ZAR", "SSP", "LKR",
    "SDG", "SRD", "SEK", "CHF", "SYP", "TWD", "TJS", "TZS", "THB",
    "TOP", "TTD", "TND", "TRY", "TMT", "UGX", "UAH", "AED", "USD",
    "UYU", "UZS", "VUV", "VES", "VND", "XPF", "YER", "ZMW", "ZWG",
]);

// -----------------------------------------------------------------------------
// Enabled currencies (static fallback when geography master is empty)
// -----------------------------------------------------------------------------
const ENABLED_CURRENCIES = CURRENCIES.filter((currency) =>
    SUPPORTED_CODES.has(currency.code)
);


// -----------------------------------------------------------------------------
// Currency hook — prefers public.geography_currencies via /geography/currencies
// -----------------------------------------------------------------------------
export const useCurrencyCodes = () => {
    const { axiosInstance } = useAuth() || {};
    const [currencies, setCurrencies] = useState(ENABLED_CURRENCIES);

    useEffect(() => {
        if (!axiosInstance) return undefined;
        let cancelled = false;
        (async () => {
            try {
                const list = await fetchCurrencies(axiosInstance);
                if (cancelled || !Array.isArray(list) || list.length === 0) return;
                setCurrencies(
                    list.map((c) => ({
                        code: c.code,
                        name: c.name || c.code,
                        symbol: c.symbol || c.code,
                    }))
                );
            } catch (err) {
                console.error('Failed to load currencies from geography master:', err);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [axiosInstance]);

    const getByCode = (code) =>
        currencies.find((c) => c.code === String(code).toUpperCase()) || null;

    const getByName = (name) =>
        currencies.find(
            (c) => c.name.toLowerCase() === String(name).toLowerCase()
        ) || null;

    const getAllBySymbol = (symbol) =>
        currencies.filter((c) => c.symbol === symbol);

    const isValidCurrencyCode = (code) =>
        currencies.some((c) => c.code === String(code).toUpperCase());

    const resolve = ({ code, name, symbol } = {}) => {
        if (code) return getByCode(code);
        if (name) return getByName(name);
        if (symbol) return getAllBySymbol(symbol)[0] || null;
        return null;
    };

    const getField = (identifier, field) => {
        const entry = resolve(identifier);
        return entry ? entry[field] : null;
    };

    const getSymbol = (identifier) => getField(identifier, 'symbol');
    const getName = (identifier) => getField(identifier, 'name');
    const getCode = (identifier) => getField(identifier, 'code');

    const searchCurrencies = (query = '') => {
        const q = query.trim().toLowerCase();
        if (!q) return currencies;
        return currencies.filter(
            (c) =>
                c.code.toLowerCase().startsWith(q) ||
                c.name.toLowerCase().includes(q)
        );
    };

    const toDropdownOptions = ({
        labelFormat = 'nameCode',
        sortAlphabetically = true,
    } = {}) => {
        const list = sortAlphabetically
            ? [...currencies].sort((a, b) => a.name.localeCompare(b.name))
            : currencies;

        const buildLabel = (c) => {
            switch (labelFormat) {
                case 'name':
                    return c.name;
                case 'code':
                    return c.code;
                case 'nameSymbol':
                    return `${c.name} (${c.symbol})`;
                case 'codeSymbol':
                    return `${c.code} (${c.symbol})`;
                case 'codeName':
                    return `${c.code} - ${c.name}`;
                case 'nameCode':
                default:
                    return `${c.name} (${c.code})`;
            }
        };

        return list.map((c) => ({
            value: c.code,
            label: buildLabel(c),
            code: c.code,
            name: c.name,
            symbol: c.symbol,
        }));
    };

    return {
        currencies,
        getByCode,
        getByName,
        getAllBySymbol,
        isValidCurrencyCode,
        resolve,
        getField,
        getSymbol,
        getName,
        getCode,
        searchCurrencies,
        toDropdownOptions,
    };
};
